import { useMemo } from "react";

export function useUnaffiliatedMembers<T>(
    workspaceAssignments: Array<T & { organizationId: string | null }>,
): Array<T & { organizationId: string | null }> {
    return useMemo(
        () => workspaceAssignments.filter((a) => !a.organizationId),
        [workspaceAssignments],
    );
}
